import { useMemo } from 'react';
import get from 'lodash/get';
import Highcharts from 'highcharts';
import { makeObjectOutOfArrays } from '../../../../utils';
import { ADDITIONAL_METRIX_OPTIONS } from '../../../../constants';

const useTransformAdditionalMetricsData = (item, timeperiodLabel, selectedMetrix) => {
    return useMemo(() => {
        const columns = get(item, 'cstData.columns', []);
        const metric_data = get(item, 'cstData.metric_data', []);
        const dataObj = makeObjectOutOfArrays(columns, metric_data?.[0]);
        const isData = !!item?.cstData && get(item, 'cstData.metric_data', []).length;
        const subTitle = `Time Period: ${timeperiodLabel}`;
        const options = get(item, 'data', {});

        const selectedMetrixLabel = ADDITIONAL_METRIX_OPTIONS?.find(e => e.value === selectedMetrix)?.label;
        const isPercentage = selectedMetrix === 'percentage';
        const seriesData = isPercentage ? [dataObj?.yes_percentage, dataObj?.no_percentage] : [dataObj?.yes_count, dataObj?.no_count];

        const extraConfig = {
            tooltip: {
                positioner: function (labelWidth, labelHeight, point) {
                    const chart = this.chart;
                    return {
                        x: chart.plotLeft + chart.plotWidth / 2 - labelWidth / 2,
                        y: point.plotY + chart.plotTop - labelHeight - 12
                    };
                },

                formatter: function () {
                    const value = Highcharts.numberFormat(this.y, 2);
                    return `
              <div style="
                background: #1e222c;
                color: #fff;
                padding: 12px 18px;
                border-radius: 14px;
                font-size: 14px;
                box-shadow: 0 4px 14px rgba(0,0,0,0.25);
                display: flex;
                flex-direction: column;
                gap: 6px;
                pointer-events: none;
              ">
                <div style="font-size: 14px; font-weight: 600;">${this.key}</div>
        
                <div style="display: flex; align-items: center; justify-content: space-between;">
                  <div style="display: flex; align-items: center; gap: 6px;">
                    <div style="
                      width: 10px; height: 10px;
                      background: ${this.color};
                    "></div>
                    <span style="opacity: 0.8;">${selectedMetrixLabel}&nbsp;&nbsp;&nbsp;&nbsp;</span>
                  </div>
                  <span style="font-weight: 600;">${value}${isPercentage ? '%' : ''}</span>
                </div>
              </div>
              <div style="
                width: 0; height: 0; margin: 0 auto;
                border-left: 10px solid transparent;
                border-right: 10px solid transparent;
                border-top: 12px solid #1e222c;
              "></div>
            `;
                }
            },
            plotOptions: {
                series: {
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: true,
                        formatter: function () {
                            const value = this.y;
                            const isPercentage = selectedMetrix === 'percentage';
                            if (value == null) {
                                return isPercentage ? '0.00%' : '0.00';
                            } else {
                                return isPercentage ? value.toFixed(2) + '%' : value;
                            }
                        }
                    }
                }
            },
            series: [{ ...options?.series?.[0], data: seriesData }],
            yAxis: {
                ...options?.yAxis,
                title: { ...options?.yAxis?.title, text: isPercentage ? 'Percentage %' : 'Sample Size' }
            }
        };
        const chartOptions = Highcharts.merge(options, extraConfig);

        return {
            dataObj,
            isData,
            subTitle,
            options,
            chartOptions,
            selectedMetrixLabel
        };
    }, [item, timeperiodLabel, selectedMetrix]);
};

export default useTransformAdditionalMetricsData;